var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm.arrowLink.type === "Large Blue" ||
    _vm.arrowLink.type === "Blue Small Animated" ||
    _vm.arrowLink.type === "Small Navy Animated"
    ? _c(
        "LocaleLink",
        {
          class: _vm.arrowLinkClasses,
          attrs: { link: _vm.arrowLink.linkUrl, target: _vm.arrowLink.target },
        },
        [
          _vm._v(_vm._s(_vm.arrowLink.text) + "\n  "),
          _c(
            "svg",
            {
              staticClass: "inline",
              attrs: {
                width: "14",
                height: "11",
                viewBox: "0 0 14 11",
                fill: "none",
                xmlns: "http://www.w3.org/2000/svg",
              },
            },
            [
              _c("path", {
                attrs: {
                  d: "M6 1L11.1648 5.45055L6 9.9011",
                  stroke:
                    _vm.arrowLink.type === "Large Blue" ||
                    _vm.arrowLink.type === "Blue Small Animated"
                      ? "#0384FB"
                      : "#00263e",
                  "stroke-width": "2.5",
                },
              }),
              _vm._v(" "),
              _c("rect", {
                attrs: {
                  y: "4.25",
                  width: "11",
                  height: "2.5",
                  fill:
                    _vm.arrowLink.type === "Large Blue" ||
                    _vm.arrowLink.type === "Blue Small Animated"
                      ? "#0384FB"
                      : "#00263e",
                },
              }),
            ]
          ),
        ]
      )
    : _vm.arrowLink.type === "Blue Arrowless"
    ? _c(
        "p",
        {
          staticClass:
            "a--link-arrow-arrowless text-blue relative inline-block no-underline pb-1/4",
        },
        [
          _c(
            "LocaleLink",
            {
              class: _vm.arrowLinkClasses,
              attrs: {
                link: _vm.arrowLink.linkUrl,
                target: _vm.arrowLink.target,
              },
            },
            [_vm._v(_vm._s(_vm.arrowLink.text))]
          ),
          _c("span", {
            staticClass:
              "bg-blue w-0 duration-200 ease-in-out z-20 absolute bottom-0 left-0",
          }),
        ],
        1
      )
    : _c(
        "LocaleLink",
        {
          class: _vm.arrowLinkClasses,
          attrs: { link: _vm.arrowLink.linkUrl, target: _vm.arrowLink.target },
        },
        [_vm._v(_vm._s(_vm.arrowLink.text) + "\n")]
      )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }